import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a404fa0")

_pushScopeId("data-v-2a404fa0")
const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_3 = {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" })
], -1)
const _hoisted_5 = { class: "accordion-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "d-flex align-items-center fs-5 fw-bold" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "d-flex align-items-center fs-5 fw-bold" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_13 = { class: "mb-2 fs-6 fw-bold" }
const _hoisted_14 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_15 = { class: "mb-2 fs-6 fw-bold alignments-widget" }
const _hoisted_16 = { class: "form-check-label fw-bold text-gray-400 mt-6 alignments-widget" }
const _hoisted_17 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createVNode("label", { class: "items-center mt-13 fs-5 fw-bolder" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-greater-than" }),
    /*#__PURE__*/_createVNode("i", { class: "fas fa-equals" })
  ])
], -1)
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "mb-2 fs-6 fw-bold" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "mb-2 fs-6 fw-bold" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "mb-7 fs-6 fw-bold alignments-widget" }
const _hoisted_25 = { class: "form-check-label fw-bold text-gray-400 alignments-widget" }
const _hoisted_26 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createVNode("label", { class: "items-center mt-13 fs-5 fw-bolder" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-less-than" })
  ])
], -1)
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "mb-2 fs-6 fw-bold" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "mb-2 fs-6 fw-bold" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "mb-7 fs-6 fw-bold alignments-widget" }
const _hoisted_34 = { class: "form-check-label fw-bold text-gray-400 alignments-widget" }
const _hoisted_35 = {
  key: 2,
  class: "row mt-5"
}
const _hoisted_36 = { class: "col-md-12 mb-3 d-flex justify-content-end pr-5" }
const _hoisted_37 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "items-center mt-13 fs-5 fw-bolder" }, "Between")
], -1)
const _hoisted_39 = { class: "col-md-2" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "mb-2 fs-6 fw-bold" }, "From", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_42 = { class: "col-md-2" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { class: "mb-2 fs-6 fw-bold" }, "To", -1)
const _hoisted_44 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_45 = { class: "col-md-2" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "mb-2 fs-6 fw-bold" }, "Price", -1)
const _hoisted_47 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { class: "mb-7 fs-6 fw-bold alignments-widget" }, "Tax Include", -1)
const _hoisted_50 = { class: "form-check-label fw-bold text-gray-400 mt-3 alignments-widget" }
const _hoisted_51 = { class: "col-md-1 d-flex align-items-center pr-0 justify-content-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.customerGroupFormData,
    ref: "customerGroupFormRef"
  }, {
    default: _withId(() => [
      _createVNode(_component_InnerLoader, {
        loading: _ctx.loader,
        innerLoading: true
      }, null, 8, ["loading"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Select, {
          name: "customer_groups",
          target: "customer_groups",
          label: _ctx.$t('message.CUSTOMER_GROUPS'),
          multiple: true,
          placeholder: _ctx.$t('message.SELECT'),
          customer_groups: _ctx.customerGroupFormData.customer_groups,
          "onUpdate:customer_groups": _cache[1] || (_cache[1] = ($event: any) => (_ctx.customerGroupFormData.customer_groups = $event)),
          selectData: _ctx.customerGroups,
          value: _ctx.customerGroupFormData.customer_groups,
          callEmit: true,
          filterable: true,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.customerGroup(_ctx.customerGroupFormData.customer_groups)))
        }, null, 8, ["label", "placeholder", "customer_groups", "selectData", "value"])
      ]),
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customerGroupRules, (ruleObject, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "accordion-item mb-5",
            key: index
          }, [
            _createVNode("h2", _hoisted_3, [
              _createVNode("button", {
                class: `accordion-button ${index != 0 ? 'collapsed' : ''}`,
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": '#panelsStayOpen-collapse_' + index,
                "aria-expanded": "true",
                "aria-controls": "panelsStayOpen-collapseOne"
              }, [
                _createTextVNode(_toDisplayString(ruleObject.data.label) + " " + _toDisplayString(_ctx.$t('message.SHIPPING_RULES')) + " ", 1),
                _hoisted_4
              ], 10, ["data-bs-target"])
            ]),
            _createVNode("div", {
              id: 'panelsStayOpen-collapse_' + index,
              class: 'accordion-collapse collapse' + (index == 0 ? ' show' : ''),
              "aria-labelledby": "panelsStayOpen-headingOne"
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('message.RULES')), 1),
                      _createVNode("div", null, [
                        _createVNode(_component_Radio, {
                          name: "customerGroupRule",
                          index: index,
                          size: "medium",
                          target: "customerGroupRule",
                          customerGroupRule: _ctx.customerGroupRule[ruleObject.data.value],
                          "onUpdate:customerGroupRule": ($event: any) => (_ctx.customerGroupRule[ruleObject.data.value] = $event),
                          options: _ctx.optionRule,
                          value: _ctx.customerGroupRule[ruleObject.data.value]
                        }, null, 8, ["index", "customerGroupRule", "onUpdate:customerGroupRule", "options", "value"])
                      ])
                    ])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_9, [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('message.CART_RULES')), 1),
                      _createVNode("div", null, [
                        _createVNode(_component_Radio, {
                          name: "customerGroupCartOption",
                          size: "medium",
                          target: "customerGroupCartOption",
                          customerGroupCartOption: _ctx.customerGroupCartOption[ruleObject.data.value],
                          "onUpdate:customerGroupCartOption": ($event: any) => (_ctx.customerGroupCartOption[ruleObject.data.value] = $event),
                          options: _ctx.cartRuleOption,
                          value: _ctx.customerGroupCartOption[ruleObject.data.value],
                          callEmit: true,
                          index: index,
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCustomerGroupShippingRuleLabel(_ctx.customerGroupCartOption)))
                        }, null, 8, ["customerGroupCartOption", "onUpdate:customerGroupCartOption", "options", "value", "index"])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.customerGroupRule[ruleObject.data.value] == 1]
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  (_ctx.customerGroupRule[ruleObject.data.value] == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('message.PRICE')), 1),
                        _createVNode(_component_el_input, {
                          type: "number",
                          min: 1,
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRICE')}`,
                          modelValue: _ctx.customerGroupFormData.customer_group_cost_no_rule[ruleObject.data.value],
                          "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_cost_no_rule[ruleObject.data.value] = $event)
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.customerGroupRule[ruleObject.data.value] == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("label", _hoisted_15, _toDisplayString(`${_ctx.$t('message.TAX')} ${_ctx.$t('message.INCLUDE')}`), 1),
                        _createVNode("span", _hoisted_16, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.customerGroupFormData.customer_group_tax_no_rule[ruleObject.data.value],
                            "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_tax_no_rule[ruleObject.data.value] = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.customerGroupRule[ruleObject.data.value] == 1 && (_ctx.customerGroupCartOption[ruleObject.data.value] == 1 || _ctx.customerGroupCartOption[ruleObject.data.value] == 0))
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("div", _hoisted_19, [
                        _createVNode("label", _hoisted_20, _toDisplayString(_ctx.customerGroupShippingLabel[ruleObject.data.value]), 1),
                        _createVNode(_component_el_input, {
                          type: "number",
                          min: 1,
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.VALUE')}`,
                          modelValue: _ctx.customerGroupFormData.customer_group_cart_rules[ruleObject.data.value],
                          "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_cart_rules[ruleObject.data.value] = $event)
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('message.PRICE')), 1),
                        _createVNode(_component_el_input, {
                          type: "number",
                          min: 1,
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRICE')}`,
                          modelValue: _ctx.customerGroupFormData.customer_group_cart_cost[ruleObject.data.value],
                          "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_cart_cost[ruleObject.data.value] = $event)
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_23, [
                        _createVNode("label", _hoisted_24, _toDisplayString(`${_ctx.$t('message.TAX')} ${_ctx.$t('message.INCLUDE')}`), 1),
                        _createVNode("span", _hoisted_25, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.customerGroupFormData.customer_group_tax[ruleObject.data.value],
                            "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_tax[ruleObject.data.value] = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.customerGroupRule[ruleObject.data.value] == 1 && (_ctx.customerGroupCartOption[ruleObject.data.value] == 1 || _ctx.customerGroupCartOption[ruleObject.data.value] == 0))
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode("div", _hoisted_28, [
                        _createVNode("label", _hoisted_29, _toDisplayString(_ctx.customerGroupShippingLabel[ruleObject.data.value]), 1),
                        _createVNode(_component_el_input, {
                          type: "number",
                          min: 1,
                          placeholder: "Please input",
                          modelValue: _ctx.customerGroupFormData.customer_group_cart_rules2[ruleObject.data.value],
                          "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_cart_rules2[ruleObject.data.value] = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_30, [
                        _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('message.PRICE')), 1),
                        _createVNode(_component_el_input, {
                          type: "number",
                          min: 1,
                          placeholder: "Please input",
                          modelValue: _ctx.customerGroupFormData.customer_group_cart_cost2[ruleObject.data.value],
                          "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_cart_cost2[ruleObject.data.value] = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("label", _hoisted_33, _toDisplayString(`${_ctx.$t('message.TAX')} ${_ctx.$t('message.INCLUDE')}`), 1),
                        _createVNode("span", _hoisted_34, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.customerGroupFormData.customer_group_tax2[ruleObject.data.value],
                            "onUpdate:modelValue": ($event: any) => (_ctx.customerGroupFormData.customer_group_tax2[ruleObject.data.value] = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.customerGroupRule[ruleObject.data.value] == 1 && _ctx.customerGroupCartOption[ruleObject.data.value] == 2)
                  ? (_openBlock(), _createBlock("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _createVNode("button", {
                          style: {"width":"48px","height":"43px"},
                          class: "btn btn-custom btn-sm px-3",
                          onClick: _withModifiers(($event: any) => (_ctx.addRow(ruleObject.data.value)), ["prevent"])
                        }, " + ", 8, ["onClick"])
                      ]),
                      (!_ctx.customerGroupFormData.combinations[ruleObject.data.value] || _ctx.customerGroupFormData.combinations[ruleObject.data.value].length === 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.$t('message.PLEASE_ADD_AT_LEAST_ONE_COMBINATION')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customerGroupFormData.combinations[ruleObject.data.value], (row, rowIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: rowIndex,
                          class: "row mt-2"
                        }, [
                          _hoisted_38,
                          _createVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createVNode(_component_el_input, {
                              required: true,
                              type: "number",
                              min: 1,
                              placeholder: "Enter Value",
                              modelValue: row.firstValue,
                              "onUpdate:modelValue": ($event: any) => (row.firstValue = $event),
                              class: { 'is-invalid': _ctx.showValidationErrors && (!row.firstValue || Number(row.firstValue) <= 0) }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                            (_ctx.showValidationErrors && (!row.firstValue || Number(row.firstValue) <= 0))
                              ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('message.FIRST_VALUE_MUST_BE_GREATER_THAN_0')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode(_component_el_input, {
                              required: true,
                              type: "number",
                              min: row.firstValue,
                              placeholder: "Enter Value",
                              modelValue: row.secondValue,
                              "onUpdate:modelValue": ($event: any) => (row.secondValue = $event),
                              class: { 'is-invalid': _ctx.showValidationErrors && (!row.secondValue || Number(row.secondValue) <= 0) }
                            }, null, 8, ["min", "modelValue", "onUpdate:modelValue", "class"]),
                            (_ctx.showValidationErrors && (!row.secondValue || Number(row.secondValue) <= 0))
                              ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('message.SECOND_VALUE_MUST_BE_GREATER_THAN_0')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createVNode(_component_el_input, {
                              required: true,
                              type: "number",
                              min: 1,
                              placeholder: "Enter Price",
                              modelValue: row.price,
                              "onUpdate:modelValue": ($event: any) => (row.price = $event),
                              class: { 'is-invalid': _ctx.showValidationErrors && (!row.price || Number(row.price) <= 0) }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                            (_ctx.showValidationErrors && (!row.price || Number(row.price) <= 0))
                              ? (_openBlock(), _createBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('message.PRICE_MUST_BE_GREATER_THAN_0')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createVNode("span", _hoisted_50, [
                              _createVNode(_component_el_switch, {
                                modelValue: row.tax,
                                "onUpdate:modelValue": ($event: any) => (row.tax = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_51, [
                            _createVNode("button", {
                              class: "btn btn-danger mt-7",
                              onClick: _withModifiers(($event: any) => (_ctx.removeRow(ruleObject.data.value, rowIndex)), ["prevent"])
                            }, " - ", 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, ["id"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["model"]))
})